/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Articles } from '../../models/articles';
import { ArticlesResponse } from '../../models/articles-response';
import { KeyType } from '../../models/key-type';

export interface PostDeliveryNoteArticles$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;
      body: Articles
}

export function postDeliveryNoteArticles(http: HttpClient, rootUrl: string, params: PostDeliveryNoteArticles$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticlesResponse>> {
  const rb = new RequestBuilder(rootUrl, postDeliveryNoteArticles.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticlesResponse>;
    })
  );
}

postDeliveryNoteArticles.PATH = '/organization-sites/{organizationSiteKey}/consignor/delivery-notes/{deliveryNoteKey}/articles';
